import { useLocation } from "react-router-dom";
import { AppDownloadBanner } from "@/components/landing/AppDownloadBanner";

const PUBLIC_PREFIXES = [
  "/legacy",
  "/pest",
  "/trial",
  "/demo",
  "/contact",
  "/privacy",
  "/terms",
  "/cookies",
  "/dpa",
  "/blog",
  "/opiniones",
  "/booking",
  "/auth",
  "/register",
];

function isPublicPath(pathname: string): boolean {
  if (pathname === "/complete-registration") return false;
  if (pathname === "/") return true;
  return PUBLIC_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

/**
 * Mounts the slick "download our app" banner only on public marketing /
 * auth pages — never inside the authenticated product or in the native app.
 */
export function PublicAppBannerHost() {
  const { pathname } = useLocation();
  if (!isPublicPath(pathname)) return null;
  return <AppDownloadBanner />;
}

export default PublicAppBannerHost;
